import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';
import InfoIconThinOutline from 'svg/InfoIconThinOutline';

export const VARIANTS = {
  NEW_MATCH: 'newMatch',
  UNLINKED: 'unlinked',
} as const;

export type Variant = (typeof VARIANTS)[keyof typeof VARIANTS];

type Props = {
  variant: Variant;
};

const MESSAGES: Record<Variant, string> = {
  newMatch: 'A new record has been found as a match',
  unlinked: 'These records have been unlinked',
};

export default function InfoBanner({ variant }: Props) {
  return (
    <Banner>
      <InfoIconThinOutline size={14} />
      <Message>{MESSAGES[variant]}</Message>
    </Banner>
  );
}

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: ${colors.black05};
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
`;

const Message = styled(BodySmall)`
  margin: 0;
`;
